import { createNamespacedHelpers } from 'vuex';

import { COURSE_DRAFT_INITIALIZE, COURSE_DRAFT_FILL, CREATE_DRAFT_COURSE } from '@/store/course/types';
import { FETCH_AVAILABLE_DATES, FETCH_AVAILABLE_TIMES } from '@/store/coach/types';

const { mapState: mapCourseState, mapActions: mapCourseActions, mapMutations: mapCourseMutations } = createNamespacedHelpers('course');
const { mapState: mapCoachState, mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    computed: {
        ...mapCoachState([
            'coach',
            'available_dates',
            'available_times',
        ]),
        ...mapCourseState([
            'draft',
            'created',
        ]),
    },
    methods: {
        ...mapCoachActions({
            fetchAvailableDates: FETCH_AVAILABLE_DATES,
            fetchAvailableTimes: FETCH_AVAILABLE_TIMES,
        }),
        ...mapCourseActions({
            createDraft: CREATE_DRAFT_COURSE,
        }),
        ...mapCourseMutations({
            initializeDraft: COURSE_DRAFT_INITIALIZE,
            fillDraft: COURSE_DRAFT_FILL,
        }),
    },
};



// WEBPACK FOOTER //
// ./src/components/course/draft.mixin.js